export default __webpack_public_path__ + "static/media/squemaCFDIS-mobile.e9fbb3d4.svg";